/* ==========================================================================
   PDP: active state when selecting size on the PDP
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var input = event.target;

    if (!input.matches || !input.matches('.product-form__input input[type="radio"]')) return;

    var fieldset = input.closest('.product-form__input');
    if (!fieldset) return;

    fieldset.querySelectorAll('label.active').forEach(function (label) {
      label.classList.remove('active');
    });

    var activeLabel = fieldset.querySelector('label[for="' + input.id + '"]');
    if (activeLabel) {
      activeLabel.classList.add('active');
    }
  });
})();


/* ==========================================================================
   OTA: toast "kortingscode toegepast"
   Styling staat in de stylesheet (.ota-toast)
   ========================================================================== */
(function () {
  'use strict';

  var I18N = {
    nl: 'Kortingscode toegepast:',
    cs: 'Slevový kód byl použit:',
    da: 'Rabatkode anvendt:',
    de: 'Rabattcode angewendet:',
    en: 'Discount code applied:',
    es: 'Código de descuento aplicado:',
    fi: 'Alennuskoodi käytetty:',
    fr: 'Code de réduction appliqué :',
    it: 'Codice sconto applicato:',
    nb: 'Rabattkode brukt:',
    pl: 'Zastosowano kod rabatowy:',
    pt: 'Código de desconto aplicado:',
    sv: 'Rabattkod tillämpad:'
  };

  var LANG_ALIASES = { no: 'nb', nn: 'nb', dk: 'da', cz: 'cs' };
  var FALLBACK_LANG = 'en';

  function detectLang() {
    var raw = (window.Shopify && window.Shopify.locale)
           || document.documentElement.getAttribute('lang')
           || navigator.language
           || '';
    var lang = String(raw).trim().toLowerCase().split(/[-_]/)[0];
    return LANG_ALIASES[lang] || lang;
  }

  var CONFIG = {
    cookieName:  'discount_code',   // door Shopify gezet op /discount/CODE
    queryParam:  'discount',        // fallback: /collections/x?discount=CODE
    autoHideMs:  6000,              // 0 = blijft staan tot user sluit
    oncePerSession: true,           // niet op elke pageview opnieuw
    clearCookieOnRemove: true,      // cookie opruimen als klant de code verwijdert
    removeSelector: '.cart-discounts--remove',
    text: function (codeHtml) {
      var label = I18N[detectLang()] || I18N[FALLBACK_LANG];
      return label + ' ' + codeHtml;
    }
  };

  var STORE_PREFIX = 'ota_toast_shown:';

  function cookie(name) {
    var m = document.cookie.match('(?:^|;\\s*)' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function store(key, val) {
    try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); }
    catch (e) { return null; }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function resolveCode() {
    var fromUrl = new URLSearchParams(location.search).get(CONFIG.queryParam);
    var raw = fromUrl || cookie(CONFIG.cookieName);
    if (!raw) return null;
    raw = raw.trim().toUpperCase();
    return /^[A-Z0-9_\-]{3,64}$/.test(raw) ? raw : null;   // sanity check
  }

  function forgetDiscount(code) {
    var host = location.hostname.replace(/^www\./, '');
    document.cookie = CONFIG.cookieName + '=; Max-Age=0; path=/';
    document.cookie = CONFIG.cookieName + '=; Max-Age=0; path=/; domain=' + host;
    document.cookie = CONFIG.cookieName + '=; Max-Age=0; path=/; domain=.' + host;
    if (code) { try { sessionStorage.removeItem(STORE_PREFIX + String(code).toUpperCase()); } catch (e) {} }
  }

  function show(code) {
    var toast = document.createElement('div');
    toast.className = 'ota-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="10" fill="rgba(255,255,255,.18)"/>' +
        '<path d="M7.5 12.4l3 3 6-6.4" stroke="#fff" stroke-width="2.2" ' +
        'stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span>' + CONFIG.text('<strong>' + esc(code) + '</strong>') + '</span>' +
      '<button class="ota-toast__x" type="button" aria-label="Sluiten">&times;</button>';

    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('ota-toast--in'); });

    var timer;
    function hide() {
      clearTimeout(timer);
      toast.classList.remove('ota-toast--in');
      setTimeout(function () { toast.remove(); }, 350);
    }
    toast.querySelector('.ota-toast__x').addEventListener('click', hide);
    if (CONFIG.autoHideMs > 0) timer = setTimeout(hide, CONFIG.autoHideMs);
  }

  function init() {
    if (CONFIG.clearCookieOnRemove) {
      document.addEventListener('click', function (event) {
        var btn = event.target && event.target.closest && event.target.closest(CONFIG.removeSelector);
        if (btn) forgetDiscount(btn.dataset ? btn.dataset.discountCode : null);
      }, true);
    }

    var code = resolveCode();
    if (!code) return;

    var key = STORE_PREFIX + code;
    if (CONFIG.oncePerSession && store(key) === '1') return;
    store(key, '1');

    show(code);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();